import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Card,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import EmptyData from "components/EmptyData";
import SubscriptionEscortPricingModal from "DialogBox/subscriptionEscortPricingModal";
import apiClient from "Utils/apiClient";

const SubscriptionEscortPricing = () => {
  const [allData, setAllData] = useState([]);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) navigate("/authentication/sign-in");
  }, [navigate]);

  const fetchEscortPricing = async () => {
    try {
      const response = await apiClient.get("/escort-pricing");
      console.log("Fetched Escort Pricing Data:", response);
      if (response && response.data) {
        setAllData(response.data);
      } else {
        setAllData([]);
      }
    } catch (error) {
      console.error("Error fetching escort pricing:", error);
      toast.error("Failed to fetch Escort Pricing data.");
    }
  };

  useEffect(() => {
    fetchEscortPricing();
  }, []);

  const handleDelete = async (id) => {
    try {
      await apiClient.delete(`/escort-pricing/${id}`);
      toast.success("Escort Pricing deleted successfully.");
      fetchEscortPricing();
    } catch (error) {
      toast.error("Failed to delete Escort Pricing.");
      console.error("Delete Error:", error);
    }
  };

  const openModal = (data = null) => {
    setEditData(data);
    setOpen(true);
  };

  const closeModal = () => {
    setEditData(null);
    setOpen(false);
    fetchEscortPricing();
  };

  return (
    <DashboardLayout>
      <MDBox pt={8} pb={3}>
        <button
          className="btn btn-success ms-3 pt-2 pb-2 mb-5"
          style={{ width: 200 }}
          onClick={() => openModal()}
        >
          Add Escort Pricing
        </button>

        <SubscriptionEscortPricingModal
          open={open}
          onClose={closeModal}
          editData={editData}
          onSubmit={closeModal}
        />

        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ textAlign: "center" }}
              >
                <ToastContainer />
                <MDTypography
                  variant="h6"
                  color="white"
                  sx={{ fontWeight: "bold", fontSize: "1.5rem" }}
                >
                  SUBSCRIPTION ESCORT PRICING
                </MDTypography>
              </MDBox>

              {allData.length > 0 ? (
                <MDBox>
                  <TableContainer component={Paper}>
                    <Table aria-label="subscription table">
                      <TableBody>
                        <TableRow>
                          {[
                            "SR",
                            "Escort Type",
                            "Pricing Type",
                            "Payment Modal",
                            "User",
                            "Base Price",
                            "Admin Fee",
                            "Currency",
                            "Action",
                          ].map((heading, idx) => (
                            <TableCell
                              key={idx}
                              style={{ fontWeight: "bold", color: "#1C87F9", fontSize: "14px" }}
                              align="center"
                            >
                              {heading}
                            </TableCell>
                          ))}
                        </TableRow>

                        {allData.map((item, index) => (
                          <TableRow key={item.id}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">{item.escort_type}</TableCell>
                            <TableCell align="center">{item.pricing_type}</TableCell>
                            <TableCell align="center">{item.payment_mode}</TableCell>
                            <TableCell align="center">{item.user}</TableCell>
                            <TableCell align="center">₦{item.base_price}</TableCell>
                            <TableCell align="center">₦{item.admin_fee}</TableCell>
                            <TableCell align="center">{item.currency}</TableCell>
                            <TableCell align="center">
                              <button
                                className="btn btn-warning btn-sm me-2"
                                onClick={() => openModal(item)}
                              >
                                Update
                              </button>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDelete(item.id)}
                              >
                                Delete
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </MDBox>
              ) : (
                <EmptyData />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default SubscriptionEscortPricing;
